<div *ngIf="dispatchStop" class="step-indicator">
  <div class="line"></div>
  <div [class.last-known]="dispatchStop?.isLastKnownLocation" class="number">
    <span class="txt">{{dispatchStop.number > 0 ? dispatchStop.number : ''}}</span>
  </div>
  <div class="line"></div>
</div>
<div *ngIf="dispatchStop" class="detail">
  <div class="step-type" [ngClass]="{'last-location-label': dispatchStop?.isLastKnownLocation}">
    <span>{{getDispatchType(dispatchStop.stopType)}}</span>
    <ng-container *ngIf="dispatchStop.isCurrentLocation && dispatchStop.status !== 'departed'">
      <div class="separator"></div>
      <div i18n>Current location</div>
    </ng-container>
  </div>

  <div class="address" [ngClass]="{'step-bottom-padding': dispatchStop?.isLastKnownLocation}">
    {{dispatchStop.dispatchLocation.name}}
    <br *ngIf="dispatchStop.dispatchLocation.name" />
    <span *ngIf="dispatchStop.dispatchLocation.address1">{{dispatchStop.dispatchLocation.address1}},</span>
    <span *ngIf="dispatchStop.stopType === 'lastKnownLocation' && dispatchStop.dispatchLocation.address1"
      class="last-known-location-label">
      {{dispatchStop.lastKnownLocationTrackTime}}
    </span>
    <span>
      <span [innerHTML]="getUnknownLocationLabel()"></span>
      <span *ngIf="dispatchStop.stopType === 'lastKnownLocation' && !dispatchStop.dispatchLocation.address1"
        class="last-known-location-label">
        {{dispatchStop.lastKnownLocationTrackTime}}
      </span>
    </span>
  </div>

  <ng-container *ngIf="showDateTimeStats">
    <div *ngIf="!dispatchStop.arrivalDate && dispatchStop.scheduleDateTimeRange" class="date-time">
      {{dispatchStop.scheduleDateTimeRange}} {{dispatchStop.dateTimeZoneAbbr}}</div>
    <div *ngIf="dispatchStop.arrivalDate" class="date-time stop-status-container arrival-date date-time-bottom-padding">
      <div i18n>Arrived</div>
      <div>
        <div>{{dispatchStop.arrivalDateFormatted}} {{dispatchStop.arrivalTZ}}</div>
        <div *ngIf="dispatchStop.lateArrivalTime.length && dispatchStop.lateArrivalTime !== '0'" class="late-arrival-label">
          {{lateArrivalTime}}</div>
      </div>
    </div>
    <div *ngIf="dispatchStop.departureDateFormatted"
      [ngClass]="{'date-time-bottom-padding' : dispatchStop.isArrivalDelayed}" class="date-time stop-status-container">
      <div i18n>Departed</div>
      <div>{{dispatchStop.departureDateFormatted}} {{dispatchStop.departureTZ}}</div>
    </div>
    <div *ngIf="dispatchStop.isArrivalDelayed" class="delayed-label" i18n>Delayed</div>
  </ng-container>
</div>
